import { render, staticRenderFns } from "./FailurePreview.vue?vue&type=template&id=030b189a&scoped=true&"
import script from "./FailurePreview.vue?vue&type=script&lang=js&"
export * from "./FailurePreview.vue?vue&type=script&lang=js&"
import style0 from "./FailurePreview.vue?vue&type=style&index=0&id=030b189a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b189a",
  null
  
)

export default component.exports